import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "Main" */ '@/views/Index.vue'),
      meta: { title: '选择管理系统', icon: 'el-icon-s-home' },
    },
  ]
});
